module.exports = __webpack_public_path__ + "assets/img/bgmBg.9a760fa5.png";